/**
 * Constants for Dashboard V4 mock data
 * These should be replaced with real API data when backend integration is complete
 */

export const DASHBOARD_MOCK_VALUES = {
  // Metrics
  TOTAL_OPEN_SIGNALS: 182,
  TOTAL_OPEN_CASES: 126,
  AVERAGE_CONDUCT_SCORE: 7.2,
  
  // Vulnerability Detection
  VULNERABILITY_PERCENTAGE: 35,
  VULNERABILITY_SIGNAL_COUNT: 45,
  VULNERABILITY_WEEKLY_CHANGE: 8,
  
  // Complaint Detection
  COMMUNICATION_COUNT: 35,
  COMMUNICATION_PERCENTAGE: 35,
  QUALITY_COUNT: 30,
  QUALITY_PERCENTAGE: 30,
  BILLING_COUNT: 25,
  BILLING_PERCENTAGE: 25,
  
  // Channel Breakdown
  EMAIL_COUNT: 68,
  PHONE_COUNT: 45,
  CHAT_COUNT: 41,
  SOCIAL_COUNT: 28,
  
  // Time Series Data (Daily)
  SIGNALS_BY_DAY: [45, 52, 48, 58, 55, 42, 38],
  CASES_BY_DAY: [32, 38, 35, 42, 40, 30, 28],
  
  // Friction Hotspots - Journey Stage
  NEW_BUSINESS_COUNT: 80,
  MIDTERM_COUNT: 45,
  RENEWAL_COUNT: 38,
  CLAIMS_COUNT: 25,
  
  // Friction Hotspots - Product Line
  HOME_COUNT: 90,
  PET_COUNT: 45,
  MOTOR_COUNT: 120,
  LIFE_COUNT: 20,
  
  // Cases by Age
  THREE_DAYS_COUNT: 30,
  THREE_DAYS_PERCENTAGE: 24,
  THREE_TO_EIGHT_WEEKS_COUNT: 90,
  THREE_TO_EIGHT_WEEKS_PERCENTAGE: 71,
  EIGHT_PLUS_WEEKS_COUNT: 6,
  EIGHT_PLUS_WEEKS_PERCENTAGE: 5,
  
  // Resolution Rate
  RESOLUTION_PERCENTAGE: 85,
  AVERAGE_RESOLUTION_TIME: '4d 8h',
  
  // Root Causes
  UNCLEAR_COMMUNICATION_COUNT: 120,
  UNCLEAR_COMMUNICATION_PERCENTAGE: 66,
  BILLING_DELAY_COUNT: 80,
  BILLING_DELAY_PERCENTAGE: 44,
  PROCESS_DELAY_COUNT: 60,
  PROCESS_DELAY_PERCENTAGE: 33,
} as const;

export const MOCK_USER_DATA = {
  NAME: 'Leila',
  LAST_SESSION_TIME: 'your last session',
} as const;

/**
 * Risk thresholds for severity and priority classification
 */
export const RISK_THRESHOLDS = {
  HIGH_SEVERITY: 70,
  MEDIUM_SEVERITY: 50,
  HIGH_VULNERABILITY: 20,
  HIGH_STRAIN: 75,
  HIGH_HARM: 70,
} as const;